module.exports = __webpack_public_path__ + "media/Monitoring.5e79b250835ba682b5ec8c5843cd10b7.svg";